import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GatewayConfigFacade } from './core/plans/gateway-config.facade';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [
    RouterModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'onyxiq-esign-web';

  constructor() {
    // The session is restored by an app initializer (see app.config.ts) — by
    // the time this renders, AuthFacade already knows who is signed in.
    inject(GatewayConfigFacade).load();
  }
}
